// extracted by mini-css-extract-plugin
export default {"subtitleHighlight":"Learners_subtitleHighlight__k7x1u","article":"Learners_article__GwTEE","contactInfo":"Learners_contactInfo__4aZ5W","articles":"Learners_articles__hQ6rI"};